export const ERROR = {
    ERROR: 'ERROR',
    DEFAULT_CODE: 'TypeError',
    DEFAULT_MESSAGE_ERROR: 'It looks like there is an unknown error',
}